import { render, staticRenderFns } from "./TradeRepresentative.vue?vue&type=template&id=3b94cc6e&scoped=true"
import script from "./TradeRepresentative.vue?vue&type=script&lang=js"
export * from "./TradeRepresentative.vue?vue&type=script&lang=js"
import style0 from "./TradeRepresentative.vue?vue&type=style&index=0&id=3b94cc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b94cc6e",
  null
  
)

export default component.exports